module.exports = __webpack_public_path__ + "img/solution5.cf60ac32.png";